import style from "./savedSearch.module.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSavedSearches,
  saveSearchThunk,
  loadSearchMetaData,
} from "../../features/enhancedSearch";
import AccountHeader from "./AccountHeader";
import SavedItem from "./SavedItem";
import Dialog from "../../features/appMode/Dialog";
import { convertSavedSearches } from "../../features/search/search.util";

const AppSavedSearches = () => {
  const dispatch = useDispatch();
  const [openDialog, setopenDialog] = useState(false);
  const savedSearcheItems = useSelector(selectSavedSearches);
  const [savedSearches, setsavedSearches] = useState(convertSavedSearches(savedSearcheItems));
  const emptySearchMessages = "You have no saved searches.";

  useEffect(() => {
    setsavedSearches(convertSavedSearches(savedSearcheItems));
  }, [savedSearcheItems]);

  useEffect(() => {
    dispatch(loadSearchMetaData());
  }, [dispatch]);

  const savedResults = Array.isArray(savedSearches) ? savedSearches.slice(0, 6) : [];

  const removeSaved = (item) => {
    dispatch(saveSearchThunk({ searchTerm: item, remove: true })).then(() => {
      const filteredItems = savedSearches.filter((searchItem) => searchItem.searchText !== item);
      setsavedSearches(filteredItems);
    });
  };

  const clearSaved = () => {
    localStorage.removeItem("savedSearches");
  };

  const clearAllSaved = () => {
    clearSaved();
    setsavedSearches([]);
    setopenDialog(false);
  };

  return (
    <div className={style.accountContainer}>
      <div className={style.mobileOnly}>
        <AccountHeader headername="Saved search" />
      </div>
      {savedResults.length > 0 && (
        <button className={style.clearAllButton} onClick={() => setopenDialog(true)}>
          Clear all
        </button>
      )}
      {savedResults.length > 0 ? (
        savedResults.map((item, index) => (
          <SavedItem
            key={index}
            title={item.searchText}
            url={item.url}
            removeSaved={() => removeSaved(item.searchText)}
          />
        ))
      ) : (
        <div className={style.emptyTabLine}>{emptySearchMessages}</div>
      )}
      <Dialog
        bodyText="Are you sure you want to clear all items from your Saved Search list? This action cannot be undone."
        confirmFunction={clearAllSaved}
        heading="Confirmation"
        buttonText="Clear all"
        isOpen={openDialog}
        setIsOpen={setopenDialog}
      ></Dialog>
    </div>
  );
};

export default AppSavedSearches;
